module.exports = __webpack_public_path__ + "img/pgd_a_00101.89ddebe2.png";